export default __webpack_public_path__ + "static/media/ricevuta_acquisto_smartphonecash_-03.099d6879.svg";